<template lang="pug">
  v-content
    v-container(grid-list-md)
      v-layout(row, wrap)
        v-flex.hidden-xs-only(xs12, sm6, md4, offset-md2)
          .grey.lighten-2.pa-3.ma-1
            img(src="../../../public/libros-gracias.jpg")
        v-flex(xs12, sm6, md4)
          v-form(action="/contacto.php", method="post", ref="form", @submit="enviar")
            .text-xs-center
              h2.mt-2.secondary--text Contáctenos
            v-text-field(label="Nombre y Apellido", name="nombre", required, v-model="nombre", :rules="[rules.required]" type="text", validate-on-blur)
            v-text-field(label="Correo", name="email", required, v-model="email", :rules="[rules.required, rules.email]", type="email", validate-on-blur)
            v-text-field(label="Telefono", name="telefono", required, v-model="telefono", :rules="[rules.required]" type="text", validate-on-blur)
            v-textarea(label="Mensaje", :rows="2", name="mensaje", required, v-model="mensaje", :rules="[rules.required]", validate-on-blur)
            v-btn.secondary(block, depressed, type="submit") enviar mensaje
</template>

<script>
export default {
  data () {
    return {
      nombre: '',
      email: '',
      telefono: '',
      mensaje: '',
      rules: {
        required: value => !!value || 'Obligatorio',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Correo no válido'
        }
      }
    }
  },
  mounted () {
    this.$refs.form.reset()
  },
  methods: {
    enviar (event) {
      if (!this.$refs.form.validate()) {
        event.preventDefault()
      }
    }
  }
}
</script>

